"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, Settings } from "lucide-react";
export default function HeroDelCatalogo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="227030" id="hero" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/podcast_studio_pinheiros_main.png)] bg-cover bg-center" />

      {}
      <div className="absolute inset-0 bg-background/95 mix-blend-normal" />
      <div className="absolute inset-0 bg-primary/5 mix-blend-overlay" />

      {}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,0,0,0.05) 1px, transparent 1px)`,
      backgroundSize: "40px 40px"
    }} />

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center text-center px-4 md:px-8 max-w-5xl mx-auto transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="mb-6 inline-flex items-center justify-center p-3 bg-primary/10 rounded-full backdrop-blur-sm border border-primary/20">
          <Settings className="w-8 h-8 text-primary" />
        </div>

        {}
        <h1 className="font-default text-5xl md:text-[64px] font-bold text-foreground tracking-tighter leading-[1.1] mb-8 drop-shadow-sm">
          Estúdio de podcast em Pinheiros
          <br className="hidden md:block" /> com estrutura profissional
        </h1>

        {}
        <div className="bg-background/50 backdrop-blur-md border border-border rounded-lg p-6 md:p-8 mb-10 max-w-3xl shadow-none">
          <p className="text-muted-foreground text-lg md:text-xl font-default leading-relaxed">Grave seus episódios com <strong className="text-foreground font-bold" data-ast-id="f:/src/pages/PodcastStudioInPinheiros/sections/HeroDelCatalogo.tsx|sig:xipw1d" data-ast-start="2280" data-ast-end="2382">qualidade de cinema</strong> e suporte técnico especializado. O espaço ideal para criadores que buscam <strong className="text-foreground font-bold" data-ast-id="f:/src/pages/PodcastStudioInPinheiros/sections/HeroDelCatalogo.tsx|sig:xipw1e" data-ast-start="2503" data-ast-end="2575" contenteditable="false" style={{}}>excelência sonora</strong> e visual no coração de Pinheiros, próximo a Faria Lima.</p>
        </div>

        {}
        <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground shadow-3xl hover:bg-primary/90 text-lg px-10 h-14 font-bold transition-all hover:-translate-y-1 group">
          <Link to="https://wa.me/5511969100007">
            Agendar Gravação
            <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      </div>
    </section>;
}